import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({ name: 'customDate', pure: true })
export class CustomDatePipe implements PipeTransform {
  transform(startDate: string, endDate: string): string {
    try {
      if (dayjs(startDate).isSame(endDate, 'month')) {
        return `${dayjs(startDate).format('D')} - ${dayjs(endDate).format('D MMMM YYYY')}`;
      }
      if (dayjs(startDate).isSame(endDate, 'year')) {
        return `${dayjs(startDate).format('D MMMM')} - ${dayjs(endDate).format('D MMMM YYYY')}`;
      }
      return `${dayjs(startDate).format('D MMMM YYYY')} - ${dayjs(endDate).format('D MMMM YYYY')}`;
    } catch (error) {
      return '';
    }
  }
}
